// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__3qI6b","slideInner":"styles_slideInner__3px6N"};